var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("app-feature-icon__image " + _vm.src),style:(("background-color: " + _vm.color))})}
var staticRenderFns = []

export { render, staticRenderFns }